

export class Switch<T, R>
{
    private cases: { [value: string]: () => R; } = {};
    private default?: () => R;

    public Case(value: T, toDo: () => R): this
    {
        this.cases[value] = toDo;

        return this;
    }

    public Default(toDo: () => R): this
    {
        this.default = toDo;
        return this;
    }

    public Execute(variable: T): R
    {
        return this.cases?.[variable]?.() || this.default?.();
    }
}
